import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../utils/api';
import useUserPermissions from '../hooks/useUserPermissions';

function CreateModule() {
  const navigate = useNavigate();
  const { canModify, isLoading } = useUserPermissions();
  const [moduleId, setModuleId] = useState('');
  const [moduleDescription, setModuleDescription] = useState('');
  const [modifiedBy, setModifiedBy] = useState('');
  const [steps, setSteps] = useState([{ "Step Number": 1, "Description": '', "URL": '' }]);

  // Redirect users without modify permissions
  useEffect(() => {
    if (!isLoading && !canModify()) {
      alert('You do not have permission to create modules. Redirecting to module list.');
      navigate('/module_list');
      return;
    }
  }, [canModify, isLoading, navigate]);

  useEffect(() => {
    // A placeholder ID for display purposes only. The backend will generate the real one.
    setModuleId('MOD- (auto-generated)');
  }, []);

  const handleAddStep = () => {
    setSteps((prevSteps) => [
      ...prevSteps,
      { "Step Number": prevSteps.length + 1, "Description": '', "URL": '' },
    ]);
  };

  const handleStepChange = (index, field, value) => {
    const updatedSteps = steps.map((step, i) => 
      i === index ? { ...step, [field]: value } : step
    );
    setSteps(updatedSteps);
  };

  const handleDeleteStep = (index) => {
    const filteredSteps = steps.filter((_, i) => i !== index);
    // Re-number steps
    const renumberedSteps = filteredSteps.map((step, i) => ({ ...step, "Step Number": i + 1 }));
    setSteps(renumberedSteps);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!moduleDescription || !modifiedBy) {
        alert("Please fill out Module Description and Modified By fields.");
        return;
    }
    
    try{
      const payload = {
        moduleDescription,
        modifiedBy,
        steps,
      };

      await apiCall('/modules', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
      });

      alert('Module created successfully!');
      navigate('/module_list');
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  return (
    <div className="container mt-4">
      <form onSubmit={handleSubmit}>
        <h2>Create New Module</h2>
        {/* Form fields JSX remains largely the same, but ensure names match state */}
        <label htmlFor="module_id">Module ID:</label>
        <input type="text" id="module_id" value={moduleId} readOnly className="form-control" />

        <label htmlFor="module_description">Module Description:</label>
        <textarea id="module_description" required value={moduleDescription} onChange={(e) => setModuleDescription(e.target.value)} className="form-control" />

        <h3>Steps</h3>
        <table className="table table-bordered">
          <thead>
            <tr><th>Step Number</th><th>Description</th><th>URL</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {steps.map((step, index) => (
              <tr key={index}>
                <td><input type="text" value={step["Step Number"]} readOnly className="form-control" /></td>
                <td><input type="text" value={step.Description} onChange={(e) => handleStepChange(index, 'Description', e.target.value)} required className="form-control" /></td>
                <td><input type="url" value={step.URL} onChange={(e) => handleStepChange(index, 'URL', e.target.value)} className="form-control" /></td>
                <td><button type="button" onClick={() => handleDeleteStep(index)} className="btn btn-danger">Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        <button type="button" onClick={handleAddStep} className="btn btn-success">+ Add Step</button>

        <br /><br />
        <label htmlFor="modified_by">Modified By:</label>
        <input type="text" id="modified_by" required value={modifiedBy} onChange={(e) => setModifiedBy(e.target.value)} className="form-control" />
        
        <div className="mt-3">
          <button type="submit" className="btn btn-primary">Submit</button>
          <button type="button" onClick={() => navigate('/module_list')} className="btn btn-secondary mx-2">Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default CreateModule;

// // import React, { useState } from 'react';
// import React, { useState, useEffect } from 'react';

// function CreateModule() {
//   const [moduleId, setModuleId] = useState('');
//   const [moduleDescription, setModuleDescription] = useState('');
//   const [modifiedBy, setModifiedBy] = useState('');
//   const [steps, setSteps] = useState([
//     { id: 1, stepNumber: '', description: '', url: '', isEditing: true },
//   ]);

//   // Dummy module ID for now, replace with actual logic to fetch/generate
//   useEffect(() => {
//     setModuleId('MOD-' + Math.floor(Math.random() * 10000));
//   }, []);

//   const handleAddStep = () => {
//     setSteps((prevSteps) => [
//       ...prevSteps,
//       { id: prevSteps.length + 1, stepNumber: '', description: '', url: '', isEditing: true },
//     ]);
//   };

//   const handleStepChange = (id, field, value) => {
//     setSteps((prevSteps) =>
//       prevSteps.map((step) => (step.id === id ? { ...step, [field]: value } : step))
//     );
//   };

//   const handleEditStep = (id) => {
//     setSteps((prevSteps) =>
//       prevSteps.map((step) => (step.id === id ? { ...step, isEditing: true } : step))
//     );
//   };

//   const handleSaveStep = (id) => {
//     setSteps((prevSteps) =>
//       prevSteps.map((step) => (step.id === id ? { ...step, isEditing: false } : step))
//     );
//   };

//   const handleDeleteStep = (id) => {
//     setSteps((prevSteps) => prevSteps.filter((step) => step.id !== id));
//   };

//   const handleClearForm = () => {
//     setModuleId('');
//     setModuleDescription('');
//     setModifiedBy('');
//     setSteps([{ id: 1, stepNumber: '', description: '', url: '', isEditing: true }]);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     // Here you would send the form data to your backend API
//     console.log({
//       moduleId,
//       moduleDescription,
//       modifiedBy,
//       steps,
//     });
//     alert('Module created (simulated)!');
//     // Optionally, navigate to another page or clear the form
//     handleClearForm();
//   };

//   return (
//     <div className="container mt-4">
//       <form onSubmit={handleSubmit}>
//         <h2>Module Details</h2>

//         <label htmlFor="module_id">Module ID:</label>
//         <input
//           type="text"
//           id="module_id"
//           name="module_id"
//           value={moduleId}
//           readOnly
//           className="form-control"
//           style={{ backgroundColor: '#d6d6d6', color: '#333' }}
//         />

//         <label htmlFor="module_description">Module Description:</label>
//         <textarea
//           id="module_description"
//           name="module_description"
//           rows="3"
//           cols="120"
//           required
//           value={moduleDescription}
//           onChange={(e) => setModuleDescription(e.target.value)}
//         ></textarea>

//         <h3>Steps</h3>
//         <table id="stepsTable">
//           <thead>
//             <tr>
//               <th>Step Number</th>
//               <th>Description</th>
//               <th>URL</th>
//               <th className="actions-column">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {steps.map((step) => (
//               <tr key={step.id}>
//                 <td>
//                   <input
//                     type="text"
//                     name="step_number[]"
//                     value={step.stepNumber}
//                     onChange={(e) => handleStepChange(step.id, 'stepNumber', e.target.value)}
//                     readOnly={!step.isEditing}
//                     required
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="text"
//                     name="description[]"
//                     value={step.description}
//                     onChange={(e) => handleStepChange(step.id, 'description', e.target.value)}
//                     readOnly={!step.isEditing}
//                     required
//                   />
//                 </td>
//                 <td>
//                   <input
//                     type="url"
//                     name="step_url[]"
//                     value={step.url}
//                     onChange={(e) => handleStepChange(step.id, 'url', e.target.value)}
//                     readOnly={!step.isEditing}
//                   />
//                 </td>
//                 <td>
//                   {step.isEditing ? (
//                     <button type="button" onClick={() => handleSaveStep(step.id)}>Save</button>
//                   ) : (
//                     <button type="button" onClick={() => handleEditStep(step.id)}>Edit</button>
//                   )}
//                   <button type="button" onClick={() => handleDeleteStep(step.id)}>Delete</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         <button type="button" onClick={handleAddStep}>+ Add Step</button>

//         <label htmlFor="modified_by">Modified By:</label>
//         <input
//           type="text"
//           id="modified_by"
//           name="modified_by"
//           required
//           value={modifiedBy}
//           onChange={(e) => setModifiedBy(e.target.value)}
//         />

//         <div className="button-container">
//           <button type="submit">Submit</button>
//           <button type="button" onClick={handleClearForm}>Clear</button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default CreateModule;